import {select, takeLatest} from "@redux-saga/core/effects";
import {CLOSE_MODAL, ModalCloseState} from "./Types";
import {RootState} from "../Reducers";
import {PayloadAction} from "@reduxjs/toolkit";

function* closeModal({payload}: PayloadAction<ModalCloseState<any>>) {

  const modalState = yield select((state: RootState) => state.ModalReducer);

  if (modalState[payload.modal].cb) {
    modalState[payload.modal].cb(payload.result);
  }
}

export function* modalSaga() {
  yield takeLatest(CLOSE_MODAL, closeModal)
}
